import { createAsyncThunk } from '@reduxjs/toolkit'
import api from '../../services'
import {
  Chapter,
  ChaptersInfo,
  GetChaptersOptions,
  GetSubjectsOptions,
  GetSubjectsResponse,
  TopicInfo
} from './type'
import apiEndpoints from '../../const/apiEndpoints'
import ROUTES from '../../const/routes'
import history from '../../const/history'

export const getSubjects = createAsyncThunk(
  'course/subject',
  async ({
    courseId,
    batchId
  }: GetSubjectsOptions): Promise<GetSubjectsResponse> => {
    const response = await api.get(`${apiEndpoints.courseChild}/${courseId}`)
    return {
      subjects: response.data.data,
      batchId: batchId
    }
  }
)

export const getChapter = createAsyncThunk(
  'course/chapter',
  async ({
    subjectId,
    subjectName,
    batchId
  }: GetChaptersOptions): Promise<ChaptersInfo> => {
    const response = await api.get(
      `${apiEndpoints.courseChild}?id=${subjectId}&batchId=${batchId}`
    )
    const chapterList = response?.data?.data

    if (chapterList) {
      history.push(ROUTES.CHAPTERS)
    }

    try {
      chapterList.sort(function (chapter1: Chapter, chapter2: Chapter) {
        return (
          new Date(chapter1.createdAt).valueOf() -
          new Date(chapter2.createdAt).valueOf()
        )
      })
    } catch (error) {
      return {
        subjectName: subjectName,
        list: chapterList
      }
    }

    chapterList.forEach((chapter: Chapter) => {
      try {
        chapter.topicMaterialResponses.sort(function (
          topic1: TopicInfo,
          topic2: TopicInfo
        ) {
          return (
            new Date(topic1?.topic?.createdAt).valueOf() -
            new Date(topic2?.topic?.createdAt).valueOf()
          )
        })
      } catch (error) {
        return {
          subjectName: subjectName,
          list: chapterList
        }
      }
    })

    return {
      subjectName: subjectName,
      list: chapterList
    }
  }
)
